var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 244,
    viewBox: "0 0 243 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 121.9,
    r: 121.5,
    fill: "#58B0F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_2634",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 243,
    height: 243
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.251,
    cy: 121.651,
    r: 121.251,
    fill: "#58B0F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_2634)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4502 123L154.45 123V111.492C154.45 104.607 149.245 99 142.853 99H105.048C98.6553 99 93.4502 104.607 93.4502 111.492V123ZM70.8889 431H177.011C187.707 431 196.45 421.624 196.45 410.154L196.45 144.846C196.45 133.376 187.8 124 177.011 124L70.8889 124C60.193 124 51.4502 133.276 51.4502 144.846L51.4502 410.154C51.4502 421.624 60.1 431 70.8889 431Z",
    fill: "#BDCCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 123.4L89.2998 123.4V111.7C89.2998 104.7 94.9998 99 102 99L134.3 99C141.3 99 147 104.7 147 111.7V123.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.144 431H67.8559C56.2804 431 47 421.594 47 410.086L47 143.914C47 132.306 56.3802 123 67.8559 123L168.144 123C179.72 123 189 132.406 189 143.914L189 410.086C189 421.594 179.62 431 168.144 431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.55 237.85C149.55 237.85 142.75 239.25 135.05 248.35C127.35 257.45 125.95 263.35 124.95 265.65C123.95 268.05 119.55 280.05 105.95 287.85C105.95 287.85 123.15 281.15 129.25 274.75C134.95 268.75 138.75 263.45 140.25 258.55C142.25 252.55 141.65 250.25 145.55 243.55C147.15 241.25 149.55 237.85 149.55 237.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.45 240.35C130.45 240.35 124.55 241.15 117.75 248.05C110.95 255.05 109.35 259.65 108.35 261.65C107.35 263.65 103.05 272.95 91.3501 278.75C91.3501 278.75 106.15 274.25 111.75 269.35C116.95 264.85 120.25 260.65 121.95 256.95C123.95 252.15 123.45 250.35 127.15 245.05C128.35 243.05 130.45 240.35 130.45 240.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 240.35C112.55 240.35 107.65 240.35 101.05 245.25C94.4502 250.25 92.8502 253.95 91.6502 255.45C90.6502 256.95 85.9502 264.25 75.4502 267.65C75.4502 267.65 88.3502 265.65 93.4502 262.15C98.2502 258.95 101.55 255.95 103.35 252.95C105.55 249.15 105.45 247.65 108.95 243.75C110.35 242.35 112.55 240.35 112.55 240.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.974 102.099H148.986C148.051 102.099 147.427 101.164 147.739 100.229L159.272 72.9551C159.584 72.02 158.96 71.085 158.025 71.085H132.154C131.375 71.085 130.752 71.5525 130.44 72.3317L110.18 120.489C109.556 121.736 110.647 123.294 112.05 123.294H115.011H134.492C135.271 123.294 135.895 124.074 135.895 124.853L128.881 166.309C128.57 167.711 130.596 168.491 131.375 167.244L167.844 105.06C168.311 103.813 167.376 102.099 165.974 102.099Z",
    fill: "#1F243B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/battery-icon.1c5d2826d819a059ea9b5575db6c8266.svg";
export { ForwardRef as ReactComponent };